import * as types from '../../../actions';
const initialState = {
    items: [],
    status:0,
    item:{
        id:'',
        name:'',
    },
    activity:'',
    count:0,
    errorData:''    
};
export default function(state = initialState, action) {
    const response = action.response;
    switch(action.type) {
        case types.CLIENT_CATEGORY_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data.results ? response.data.results : response.data,
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_LIST_SUCCESS,
                    count:response.data.count
                };
            }else{
                return {
                    ...state,
                    status: response.status,     
                    activity:types.CLIENT_CATEGORY_LIST_ERROR,                            
                };
            }       

        case types.CLIENT_CATEGORY_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_ADD_SUCCESS,
                }   
            }else{
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_ADD_ERROR,
                }   
            }
        case types.CLIENT_CATEGORY_EDIT_SUCCESS:     
            if(response.status===200){     
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        name: response.data.name
                    },
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_EDIT_SUCCESS,               
                }     
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_EDIT_ERROR,         
                }   
            }  
       
        case types.CLIENT_CATEGORY_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_UPDATE_SUCCESS,         
                }    
            }else{
                return {
                    ...state,                  
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_UPDATE_ERROR, 
                    errorData: response.data,        
                }    
            }       

        case types.CLIENT_CATEGORY_DELETE_SUCCESS:
            const id = response.data.id;     
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),               
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_DELETE_SUCCESS,   
                }       
    
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.CLIENT_CATEGORY_DELETE_ERROR,  
                    errorData: response.data, 
                }       
    
            }           
            
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    name:''
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
    }
  };